// extracted by mini-css-extract-plugin
export default {"react_tabs_tab":"DefaultReviews_react_tabs_tab__1bw3-","pendingItemCount":"DefaultReviews_pendingItemCount__KGTYw"};